import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Maintenance} from "../../models/maintenance";
import {CalendarEvent} from "../../models/calendar-event";
import {Equipment} from "../../models/equipment";
import {PhysicalAsset} from "../../models/physical-asset";
import {EventManagerService} from "../../services/event-manager.service";
import {ActivatedRoute, Router} from "@angular/router";
import {EquipmentManagerService} from "../../services/equipment-manager.service";
import {PhysicalAssetManagerService} from "../../services/physical-asset-manager.service";
import {RepositoryService} from "../../services/repository.service";
import {MaintenanceManagerService} from "../../services/maintenance-manager.service";
import {combineLatest} from "rxjs";
import {AngularFireAuth} from "@angular/fire/auth";
import {skipWhile, take} from "rxjs/operators";
import {Utils} from "../../utils";
import {AssistanceType} from "../../models/assistance";
import {AccountManagerService} from "../../services/account-manager-service";

@Component({
  selector: 'app-training-page',
  templateUrl: './training-page.component.html',
  styleUrls: ['./training-page.component.scss']
})
export class TrainingPageComponent implements OnInit {

  isTrainingStarted = false;
  loading = true;
  isAnonymousUser = false;

  event: CalendarEvent;
  equipment: Equipment;
  asset: PhysicalAsset;

  equipmentImageUrl: string;

  fakeMaintenance: Maintenance;
  userName: string;
  userSurname: string;
  userId: string;

  canClose = true;

  constructor(
    private eventManagerService: EventManagerService,
    private equipmentManagerService: EquipmentManagerService,
    private physicalAssetManagerService: PhysicalAssetManagerService,
    private repositoryService: RepositoryService,
    private maintenanceManagerService: MaintenanceManagerService,
    private accountManagerService: AccountManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {

    combineLatest([
      this.route.paramMap,
      this.route.data,
    ]).pipe(take(1)).subscribe(async combinations => {

      const paramMap = combinations[0];
      this.isAnonymousUser = combinations[1] && combinations[1].isAnonymousUser;

      const trainingRoom = paramMap.get('training-room');

      // Anonymous info
      const roomAccessCode = localStorage.getItem('access-code');
      this.userName = localStorage.getItem('name');
      this.userSurname = localStorage.getItem('surname');
      this.userId = this.accountManagerService.account.id;

      // Remove access code from storage
      localStorage.removeItem('access-code');

      // Get event info
      this.event = await this.eventManagerService.getEvent(trainingRoom, () => this.router.navigate(['404']));
      this.equipment = this.event.equipment.model;
      this.asset = this.event.equipment;

      // Get image url
      this.equipmentImageUrl = this.equipment.imageUrl || 'assets/img/no-image.png';

      // Enable start training button without page refresh
      this.autoEnableStartTrainingButton();

      this.loading = false;

    });

  }

  canStartTraining() {
    return this.event.scheduledAt <= Date.now() && Date.now() <= this.event.endAt;
  }

  get startTrainingButtonText() {
    if (this.event.scheduledAt <= Date.now() && Date.now() <= this.event.endAt) {
      return 'Start training session';
    } else if (Date.now() < this.event.scheduledAt) {
      return 'Wait the schedule date';
    } else if (this.event.endAt < Date.now()) {
      return 'Event expired';
    }
  }

  startTraining() {

    // @ts-ignore
    this.fakeMaintenance = {
      id: this.event.id, // We can use the event id as maintenance uid
      equipment: this.asset
    } as Maintenance;

    this.isTrainingStarted = true;

  }

  autoEnableStartTrainingButton() {
    if (Date.now() < this.event.scheduledAt) {
      Utils.setToHappen(() => {
        this.cdr.detectChanges();
      }, new Date(this.event.scheduledAt + 1000));
    }
  }

  async closeTraining() {
    this.canClose = false;
    await this.eventManagerService.closeTraining(this.event.id, this.event);
    this.router.navigate(['calendar']);
  }

  get AssistanceType() { return AssistanceType }

}
